import React from 'react';
import { Box } from '@mafc/trolly';
import COLORS from 'theme/colors';
import { IOrderConfirmationShipment } from 'pages/OrderConfirmation/OrderConfirmation.types';
import { IFinalPrice } from 'utils/price.util';
import CardDivider from 'pages/Checkout/components/CheckoutOrderSummary/snippets/CardDivider';
import useApigeeLabels from 'common/ApigeeLabels/hooks/useApigeeLabels';
import OrderSummaryRow from 'common/OrderSummary/components/OrderSummaryRow';
import SummaryRowTypes from 'common/OrderSummary/components/OrderSummaryRow/row.types';

const ShipmentOrderSummary: React.FC<{
  shipments: IOrderConfirmationShipment[];
  subTotal: IFinalPrice;
}> = ({ shipments, subTotal }) => {
  const { headerShipmentSubTotal } = useApigeeLabels();

  return (
    <>
      <Box mb={3}>
        <OrderSummaryRow
          label={headerShipmentSubTotal}
          priceDetails={subTotal}
          testId={headerShipmentSubTotal}
          variant={SummaryRowTypes.header}
        />

        {shipments.map(({ shipmentNameLabel, shipmentTotal, type }) => {
          return (
            <OrderSummaryRow
              label={shipmentNameLabel}
              priceDetails={shipmentTotal}
              testId={shipmentNameLabel}
              key={type}
            />
          );
        })}
      </Box>

      <CardDivider mb={12} width={1} bg={COLORS.MERCURY} />
    </>
  );
};

export default ShipmentOrderSummary;
